import React from 'react';
import { useNavigate } from 'react-router';

import styled from 'styled-components';

import { useBookingEvent } from '@components/EventDrawer/BookingEvent/BookingEventContext';
import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';
import ProjectTitle from '@components/Project/ProjectTitle';
import ProjectCard from '@components/ProjectCard/ProjectCard';
import { ProjectSelectorCard } from '@components/ProjectCard/ProjectSelectorCard';
import TravelPlanCard from '@components/TravelPlanCard/TravelPlanCard';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Header = styled.div`
    border-bottom: ${(props) => props.$mobileView && '2px solid #f0f0f0'};
    height: ${(props) => (props.$mobileView ? 'auto' : '160px')};
    padding: 0.5rem 1.5rem 1rem 1.5rem;

    .expand-icon-container {
        position: absolute;
        right: 1.5rem;
        top: 0.5rem;
    }

    .event-header-project-title-container {
        padding-left: ${(props) => (props.$mobileView ? '2.75rem' : '3.6rem')};

        .first-line {
            margin-bottom: 0;
        }
    }
`;

const EventDrawerHeader = ({ typeName, data, modelID, onSelectProject, projectErrorMessageProps }) => {
    const hasProject = () => data && data.Project;
    const navigate = useNavigate();
    const { isMobile, breakpoint } = useBookingEvent();

    const handleMoveToProject = () => {
        if (data && data.Project) {
            navigate(`/bookings/${data.Project.ID}`);
        } else {
            return null;
        }
    };

    const getDrawerHeaderWithProjectCard = () => (
        <Header
            $mobileView={isMobile}
            className={`ant-drawer-header ${!isMobile ? 'ant-drawer-header-noborder ant-drawer-header-sticky' : ''}`}
        >
            {isMobile ? (
                <div className="event-header-project-title-container">
                    <ProjectTitle small project={data ? data.Project : null} />
                </div>
            ) : (
                <ProjectCard
                    project={data ? data.Project : null}
                    type={typeName}
                    event={data}
                    modelId={modelID}
                    projectErrorMessageProps={projectErrorMessageProps}
                />
            )}
            {data && data.Project && !isMobile && (
                <div className="expand-icon-container">
                    <NwIcon
                        icon={byPrefixAndName.fass['expand-wide']}
                        pointer
                        onClick={handleMoveToProject}
                        size="lg"
                    />
                </div>
            )}
        </Header>
    );

    const getDrawerHeaderWithProjectSelector = () => (
        <div className="ant-drawer-header">
            <ProjectSelectorCard onSelectProject={onSelectProject} />
        </div>
    );

    const getDrawerHeaderNoProject = () => <div className="ant-drawer-header">[to do]</div>;

    const getDrawerHeaderWithTravelPlanCard = () => (
        <div
            className="ant-drawer-header ant-drawer-header-sticky ant-drawer-header-noborder"
            style={{ height: '150px' }}
        >
            <FlexContainer justifyContent="space-between">
                <TravelPlanCard travelPlan={data.TravelPlan} plainMode />
            </FlexContainer>
        </div>
    );

    switch (typeName) {
        case 'ScoutingTravel':
            return getDrawerHeaderWithTravelPlanCard();
        case 'RoomLodging':
        case 'ExtJob':
            return getDrawerHeaderNoProject();
        default:
            if (hasProject()) {
                return getDrawerHeaderWithProjectCard();
            } else {
                return getDrawerHeaderWithProjectSelector();
            }
    }
};

export default EventDrawerHeader;
